type Translate = (key: string, options: { defaultValue: string }) => string;

/**
 * Satın alma ekranlarında hata metni (M12c-R20): PO ve GRN ekranları önce kendi anahtarına
 * (`purchasing.po.errors.<kod>`, `purchasing.grn.errors.<kod>`) bakar; yoksa ortak
 * `purchasing.errors.<kod>`; o da yoksa genel metin. Ortak kodların metni talebe özgüdür
 * ("this requisition"), siparişte ve mal kabulünde yanıltır.
 */
export function purchasingError(
  t: Translate,
  code: string,
  scope?: 'po' | 'grn' | 'bank' | 'ledger',
): string {
  const generic = t('purchasing.errors.GENERIC', { defaultValue: code });
  const common = t(`purchasing.errors.${code}`, { defaultValue: generic });
  // Banka değişikliğinin incelemesi (ADR 0114): kendi metinleri `supplierProfile.errors`
  if (scope === 'bank') return t(`supplierProfile.errors.${code}`, { defaultValue: common });
  // Tedarikçi carisi (ADR 0119): kendi metinleri `supplierAccount.errors`
  if (scope === 'ledger') return t(`supplierAccount.errors.${code}`, { defaultValue: common });
  return scope ? t(`purchasing.${scope}.errors.${code}`, { defaultValue: common }) : common;
}
